/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
 
/* eslint-disable no-console */
// console.log("Hello World! (from create-block-ew-steps block)");
/* eslint-enable no-console */

import { gsap } from 'gsap';

// wait until DOM is ready
document.addEventListener("DOMContentLoaded", function(event){

	console.log("DOM loaded");

	//wait until images, links, fonts, stylesheets, and js is loaded
	window.addEventListener("load", function(e) {
		console.log("window loaded");

		let steps_tl = gsap.timeline( {repeat: -1} );

		steps_tl.addLabel("first");
		steps_tl.addLabel("second", 3);
		steps_tl.addLabel("third", 6);
		steps_tl.addLabel("fourth", 9);
		steps_tl.addLabel("fifth", 12);

		// let first_step = document.querySelectorAll(".ew-steps-anim__step:nth-child(1)");
		// console.log("first_step", first_step);
		let steps_anim = document.querySelectorAll(".ew-steps-anim__step");
		let steps_conn = document.querySelectorAll(".ew-steps-anim__connector");
		// let steps_card = document.querySelectorAll(".ew-processing-steps__text>div");
		console.log("steps_anim", steps_anim[0]);
		// console.log("steps_card", steps_card[0]);
		steps_tl.to(steps_anim[0],{
			onStart: () => {
				steps_anim[4].classList.remove("ew-steps-anim__step-active")
				// steps_card[4].classList.remove("ew-processing__steps-active")
				steps_anim[0].classList.toggle("ew-steps-anim__step-active")
				// steps_card[0].classList.toggle("ew-processing__steps-active")
				steps_conn[0].classList.toggle("ew-steps-anim__connector-active")
			}
		},"first");
		steps_tl.to(steps_anim[1],{
			onStart: () => {
				steps_anim[0].classList.toggle("ew-steps-anim__step-active")
				// steps_card[0].classList.toggle("ew-processing__steps-active")
				steps_conn[0].classList.toggle("ew-steps-anim__connector-active")
				steps_anim[1].classList.toggle("ew-steps-anim__step-active")
				// steps_card[1].classList.toggle("ew-processing__steps-active")
				steps_conn[1].classList.toggle("ew-steps-anim__connector-active")
			}
		},"second");
		steps_tl.to(steps_anim[2],{
			onStart: () => {
				steps_anim[1].classList.toggle("ew-steps-anim__step-active")
				// steps_card[1].classList.toggle("ew-processing__steps-active")
				steps_conn[1].classList.toggle("ew-steps-anim__connector-active")
				steps_anim[2].classList.toggle("ew-steps-anim__step-active")
				// steps_card[2].classList.toggle("ew-processing__steps-active")
				steps_conn[2].classList.toggle("ew-steps-anim__connector-active")
			}
		},"third");
		steps_tl.to(steps_anim[3],{
			onStart: () => {
				steps_anim[2].classList.toggle("ew-steps-anim__step-active")
				// steps_card[2].classList.toggle("ew-processing__steps-active")
				steps_conn[2].classList.toggle("ew-steps-anim__connector-active")
				steps_anim[3].classList.toggle("ew-steps-anim__step-active")
				// steps_card[3].classList.toggle("ew-processing__steps-active")
				steps_conn[3].classList.toggle("ew-steps-anim__connector-active")
			}
		},"fourth");
		steps_tl.to(steps_anim[4],{
			onStart: () => {
				steps_anim[3].classList.toggle("ew-steps-anim__step-active")
				// steps_card[3].classList.toggle("ew-processing__steps-active")
				steps_conn[3].classList.toggle("ew-steps-anim__connector-active")
				steps_anim[4].classList.toggle("ew-steps-anim__step-active")
				// steps_card[4].classList.toggle("ew-processing__steps-active")
			},
			duration: 3
		},"fifth");

	});
});

